import * as React from 'react';
import { FC } from 'react';

import './TimelineFullImage.scss';

interface ITimelineFullImageProps {
    image: any;

}

const TimelineFullImage: FC<ITimelineFullImageProps> = ({image}) => {

    return (
        <img src={image} className="vertical-timeline-full-image" />
    );
}

export default TimelineFullImage;